import React from "react";
import "./about-main.css";
import aboutImage from "../assets/images/about-us.jpg";   // ← adjust path if needed

const AboutMain = () => {
  return (
    <section className="about-main">
      {/* Background Blob */}
      <div className="background-blob"></div>

      {/* Floating Shapes (optional – remove if not needed) */}
      <div className="floating-shape shape1"></div>
      <div className="floating-shape shape2"></div>
      <div className="floating-shape shape3"></div>

      <div className="about-content">
        {/* Text Section */}
        <div className="text-block">
          <h1>
            Empowering Your <span>Financial Future</span>
          </h1>

          <p>
  Fundswalle is a product of Marathon Finlease, an RBI-licensed NBFC (B-14.01969). We are dedicated to providing transparent, reliable, and customer-centric financial solutions designed to meet your needs. Our focus on trust, compliance, and innovation ensures a secure and seamless financial experience at every step.
</p>


          {/* Stats Cards */}
          <div className="stats-cards">
            <div className="card">
              <h2>1000+</h2>
              <p>Happy Clients</p>
            </div>
            <div className="card">
              <h2>24/7</h2>
              <p>Support</p>
            </div>
            <div className="card">
              <h2>99%</h2>
              <p>Customer Satisfaction</p>
            </div>
          </div>
        </div>

        {/* Image Section */}
        <div className="image-block">
          <img
            src={aboutImage}
            alt="About Us"
          />

          {/* Callout Bubble */}
          <div className="callout-bubble">
            Trusted by <strong>1000+ Businesses</strong>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutMain;
